<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <navbar>
            <template v-slot:navbarname>
                <b-link
                        :to="{name:'Sliders'}"
                        class="btn btn-primary btn-round">
                    back
                </b-link>
            </template>
        </navbar>

        <h2>Update Slider</h2>

        <b-card>
            <div class="table-responsive">
                <b-table-simple>
                    <b-thead>
                        <b-tr>
                            <b-th>desktop</b-th>
                            <b-th>tablet</b-th>
                            <b-th>mobile</b-th>
                        </b-tr>
                    </b-thead>

                    <b-tbody>
                        <b-tr>
                            <b-td>
                                <b-img :src="item.slider_image_url" width="120" height="120" placeholder="not-loading"></b-img>
                            </b-td>
                            <b-td>
                                <b-img :src="item.slider_image_url_tablet" width="120" height="120" placeholder="not-loading"></b-img>
                            </b-td>
                            <b-td>
                                <b-img :src="item.slider_image_url_mobile" width="120" height="120" placeholder="not-loading"></b-img>
                            </b-td>
                        </b-tr>
                    </b-tbody>

                </b-table-simple>
            </div>
        </b-card>

        <b-card title="Desktop">
            <template v-if="image_desktop_preview !== null">
                <b-img :src="image_desktop_preview" width="85"></b-img>
            </template>
            <b-form-file @change="onSelectFileDesktop" v-model="image_desktop"></b-form-file>
        </b-card>
        <b-card title="Tablet">
            <template v-if="image_tablet_preview !== null">
                <b-img :src="image_tablet_preview" width="85"></b-img>
            </template>
            <b-form-file @change="onSelectFileTablet" v-model="image_tablet"></b-form-file>
        </b-card>
        <b-card title="Mobile">
            <template v-if="image_mobile_preview !== null">
                <b-img :src="image_mobile_preview" width="85"></b-img>
            </template>
            <b-form-file @change="onSelectFileMobile" v-model="image_mobile"></b-form-file>
        </b-card>
        <b-card title="options">
            <b-form-group label="Link Url">
                <b-input type="url" placeholder="http://example.com" v-model="slider_link"></b-input>
            </b-form-group>
            <b-form-checkbox v-model="is_hide">is hide?</b-form-checkbox>
        </b-card>

        <b-button @click="updateSliders" variant="success">{{$t('saveTitle')}}</b-button>


    </div>
</template>

<script>
    import Navbar from "../Partials/Navbar";
    import Http from '../../Services/HttpService/HttpService'
    import Notificaion from '../../Services/Notification/Nottification'

    export default {
        name: "Details",
        components: {Navbar},
        data() {
            return {
                item: [],
                image_desktop_preview: null,
                image_tablet_preview: null,
                image_mobile_preview: null,
                image_desktop: null,
                image_tablet: null,
                image_mobile: null,
                slider_link: null,
                is_hide: false
            }
        },
        methods: {
            onSelectFileDesktop(event) {
                this.image_desktop_preview = URL.createObjectURL(event.target.files[0]);
            },
            onSelectFileTablet(event) {
                this.image_tablet_preview = URL.createObjectURL(event.target.files[0]);
            },
            onSelectFileMobile(event) {
                this.image_mobile_preview = URL.createObjectURL(event.target.files[0]);
            },
            resetImages() {
                this.image_desktop = null;
                this.image_tablet = null;
                this.image_mobile = null;
                this.image_mobile_preview = null;
                this.image_tablet_preview = null;
                this.image_desktop_preview = null;
            },
            updateSliders() {
                let fd = new FormData();
                if (this.image_desktop != null) {
                    fd.append("image_desktop", this.image_desktop)
                }
                if (this.image_tablet != null) {
                    fd.append("image_tablet", this.image_tablet)
                }
                if (this.image_mobile != null) {
                    fd.append("image_mobile", this.image_mobile)
                }

                fd.append("is_hide", this.is_hide);
                fd.append("slider_link", this.slider_link);

                Http.post(Http.apiurlV2() + 'slider/update/' + this.$route.params.sliderid, fd)
                    .then(response => {
                        this.resetImages();
                        this.$Progress.finish();
                        if (response.data.status_code === Http.ok()) {
                            this.getSlider();
                            Notificaion.success(response.data.message)
                        } else {
                            Notificaion.error(response.data.message)

                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })

            },
            getSlider() {
                if (this.$route.params.sliderid && this.$route.params.sliderid > 0) {
                    this.$Progress.start();
                    Http.get(Http.apiurl() + 'slider/edit/' + this.$route.params.sliderid)
                        .then(response => {
                            this.$Progress.finish();
                            if (response.data.status_code === Http.ok()) {
                                this.item = response.data.data;
                                this.is_hide = response.data.data.slider_is_hide === "yes";
                                this.slider_link = response.data.data.slider_link;
                            } else {
                                Notificaion.error(response.data.message)

                            }
                        })
                        .catch(error => {
                            this.$Progress.finish();
                        })
                }

            },
        },
        created() {
            this.getSlider();
        }
    }
</script>

<style scoped>
    img{
        object-fit: contain;
    }
</style>